import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Toolbar, Typography, Stack, IconButton, Tooltip, CircularProgress, Button } from '@mui/material';
import { alpha } from '@mui/material';
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import DeleteIcon from '@mui/icons-material/Delete';

export default function BankTableToolbar(props) {
    const {
        numSelected,
        onSuccessClick,
        onDeleteClick,
        loading,
        title,
        titleTooltipSuccess,
        titleTooltipDelete,
        sum,
        roundToTwoDecimals,
        selectedUserIds,
        rows,
    } = props;
    const { t } = useTranslation();

    const [showUsers, setShowUsers] = useState(false);

    const buttonStyles = {
        border: '1px solid rgba(0, 171, 85, 0.3) !important',
        color: '#00AB55 !important',
        borderRadius: '8px !important',
        backgroundColor: '#fff !important',
        transition: 'all 0.25s ease-in-out',
        padding: '7px 15px !important',
        boxShadow: 'none',
        '&:hover': {
            backgroundColor: '#fff !important',
            transform: 'scale(1.05)',
            boxShadow: '0 2px 6px rgba(0, 171, 85, 0.25)',
            borderColor: '#00AB55 !important',
        },
        '&:active': {
            transform: 'scale(0.98)',
        },
    };

    useEffect(() => {
        if (selectedUserIds && selectedUserIds.length === 0) {
            setShowUsers(false);
        }
    }, [selectedUserIds]);

    const selectedUsers = rows?.filter(user => selectedUserIds.includes(user.rowId)) || [];

    if (numSelected === 0) return null;

    return (
        <Toolbar
            sx={{
                mt: 2,
                mb: 2,
                px: { xs: 1, sm: 2 },
                py: 1.5,
                ...(numSelected > 0 && {
                    bgcolor: theme => alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
                }),
            }}
        >
            <Stack spacing={3} sx={{ width: '100%' }}>
                <Stack
                    direction="row"
                    spacing={2}
                    sx={{
                        width: '100%',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <Typography sx={{ flex: '1 1 100%' }} color="inherit" variant="subtitle1" component="div">
                        {sum !== undefined ? (
                            <>
                                {title} {roundToTwoDecimals(sum)} SBK
                            </>
                        ) : (
                            <Button onClick={() => setShowUsers(!showUsers)} variant="outlined" sx={buttonStyles}>
                                {showUsers ? t('activeTransactions.hide') : `${numSelected} ${title}`}
                            </Button>
                        )}
                    </Typography>

                    <Stack direction="row" spacing={2} justifyContent="center" alignItems="center">
                        {loading ? <CircularProgress size={20} /> : null}
                        <Tooltip title={titleTooltipSuccess}>
                            <IconButton onClick={onSuccessClick} disabled={loading} sx={buttonStyles}>
                                <DoneOutlineIcon />
                            </IconButton>
                        </Tooltip>
                        {onDeleteClick && (
                            <Tooltip title={titleTooltipDelete}>
                                <IconButton onClick={onDeleteClick} disabled={loading} sx={buttonStyles}>
                                    <DeleteIcon />
                                </IconButton>
                            </Tooltip>
                        )}
                    </Stack>
                </Stack>
                <>
                    {showUsers && (
                        <Stack spacing={1} sx={{ mt: 2 }}>
                            {selectedUsers.map(user => (
                                <Typography key={user.rowId}>
                                    {user.surname
                                        ? `${user.surname} ${user.name}`
                                        : `${user.title} ${user.quantity} шт.`}
                                </Typography>
                            ))}
                        </Stack>
                    )}
                </>
            </Stack>
        </Toolbar>
    );
}
